@if (shipmentName$ | async; as name) {
  <x-shop-pill>{{ name }}</x-shop-pill>
}
